const durationOf = (loop) => Number(loop?.buffer?.duration ?? loop?.duration);

export const isCompatibleRatio = (durationA, durationB) => {
  const a = Number(durationA);
  const b = Number(durationB);
  if (!Number.isFinite(a) || !Number.isFinite(b) || a <= 0 || b <= 0) return false;
  const ratio = Math.max(a, b) / Math.min(a, b);
  return [1, 2, 4].some((target) => Math.abs(ratio - target) / target <= 0.01);
};

export const pickPair = (drums = [], melodies = []) => {
  for (const drum of drums) {
    for (const melody of melodies) {
      if (Number(drum.bpm) !== Number(melody.bpm)) continue;
      if (isCompatibleRatio(durationOf(drum), durationOf(melody))) return { drums: drum, melody };
    }
  }
  return null;
};

export const sortPacksByTempo = (packs = [], bpm = 90) => (
  [...packs].sort((a, b) => {
    const distanceA = Number.isFinite(Number(a.tempo)) ? Math.abs(Number(a.tempo) - bpm) : Infinity;
    const distanceB = Number.isFinite(Number(b.tempo)) ? Math.abs(Number(b.tempo) - bpm) : Infinity;
    return distanceA - distanceB;
  })
);

export const pickRandomPack = (packs = [], bpm = 90, random = Math.random) => {
  if (!packs.length) return null;
  const near = packs.filter((pack) => (
    Number.isFinite(Number(pack.tempo)) && Math.abs(Number(pack.tempo) - bpm) <= 10
  ));
  const choices = near.length ? near : packs;
  return choices[Math.min(choices.length - 1, Math.floor(random() * choices.length))];
};

export const scheduleBuffers = (ctx, gain, loops, startAt = ctx.currentTime + 0.1) => {
  const sources = loops.filter(Boolean).map((loop) => {
    const source = ctx.createBufferSource();
    source.buffer = loop.buffer;
    source.loop = true;
    source.connect(gain);
    source.start(startAt);
    return source;
  });
  return {
    sources,
    stop() {
      sources.forEach((source) => {
        try {
          source.stop();
          source.disconnect();
        } catch (_error) {
          // A source can already be stopped while React is cleaning up.
        }
      });
    },
  };
};
